import ru from '../i18n/ru.json';
import en from '../i18n/en.json';
import ar from '../i18n/ar.json';
import fr from '../i18n/fr.json';

function updateHtmlDirection(lang) {
  const html = document.documentElement;
  const headerLanguage = document.querySelector('.header .customSelect .selectLanguage .selectedLanguage')
  const headerMobileLanguage = document.querySelector('.headerMobile .right .customSelect .selectLanguage .selectedLanguage')
  const headerMenuMobileLanguage = document.querySelector('.headerMobile .menuMobile .customSelect .selectLanguage .selectedLanguage')

  html.setAttribute('dir', lang === 'AR' ? 'rtl' : 'ltr');

  document.querySelectorAll('.langs.customSelect .selectDropdown')
    .forEach((el) => el.setAttribute('dir', lang === 'AR' ? 'rtl' : 'ltr'));

  html.setAttribute('lang', lang);
  headerLanguage.textContent = lang;
  headerMobileLanguage.textContent = lang;
  headerMenuMobileLanguage.textContent = lang;
}

Array.prototype.last = function () {
  return this[this.length - 1]
}
document.addEventListener('DOMContentLoaded', () => {
  const data = JSON.parse(localStorage.genieLanding || '{}');
  // language settings
  const { lang } = data;

  // language init
  i18next.init({
    lng: lang || 'EN',
    debug: true,
    resources: {
      EN: {
        translation: en,
      },
      RU: {
        translation: ru,
      },
      AR: {
        translation: ar,
      },
      FR: {
        translation: fr,
      }
    }
  });

  updateHtmlDirection(lang);

  // handle submit form
  let submited = false;
  document.querySelector('form')?.addEventListener('submit', (event) => {
    event.preventDefault();

    if (!submited) {
      const formData = new FormData(event.target);
      const countryCode = document.querySelector('.country .countryCode').textContent;

      formData.delete('position');
      formData.set('phone', `${countryCode}${formData.get('phone')}`);

      grecaptcha.ready(function() {
        grecaptcha.execute('6LfJRaIoAAAAAIyn0LVU-6i44LfN1STBcvqbb9kg', {action: 'sendRegistrationClaim'}).then(function(token) {
          formData.set('gRecaptchaResponse', token)
          document.querySelector('form').querySelector('button').style.opacity = 0.3
          submited = true;
          fetch('/api/v1/landing/claims', {
              method: 'post',
              body: formData,
          }).then(() => {
              document.querySelector('.joinForm').style.display = 'none';
              document.querySelector('.successForm').style.display = 'flex';
          })
        });
      });
    }
  });

  // add gtm data
  let value;
  if (location.search) {
    data.gtm = location.search;
    localStorage.genieLanding = JSON.stringify(data);
    value = location.search;
  } else {
    value = JSON.parse(localStorage.genieLanding || '{}')?.gtm;
  }

  document.querySelector('input[type=hidden]').value = value;


  // carousel
  const carousels = [...document.querySelectorAll('.carousel')];

  carousels.map((carousel) => {
    setInterval(() => {
      const items = [...carousel.children];
      const last = items.last();
      last.style.marginLeft = `-${last.clientWidth}px`;
      carousel.prepend(last);
      setTimeout(() => {
        last.style.marginLeft = `-0px`;
      }, 50)
    }, 3000)
  });
});
